<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-button variant="outline-warning" @click="entregarDatoERP()" size="sm">
      <i class="fa fa-thumbs-o-up" aria-hidden="true"/>
    </b-button>
  </div>
</template>

<script>

export default {
  name: "BandejaInvisalingComponenteEntregar",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loading:false,
  }),
  props: {
    data: Object,
    resource: Object
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {

    entregarDatoERP() {

      const params = {
        idBandejaInvisaling: this.data.item.idBandejaInvisaling
      }
      this.$swal
          .fire({
            title: "¿Estás seguro de marcar como entregado el alineador?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {

              this.loading = true;
              this.$http
                  .post(
                      this.$api +
                      "invisalign/entregaAlineador", params
                  )
                  .then((response) => {
                    this.$swal.fire({
                      icon: 'success',
                      title: response.data.message
                    }).then(() => {
                      this.$emit("_funcionExtra", 1);
                    });
                    this.loading = false;
                  })
                  .catch((error) => {
                    this.loading = false;
                    this.$swal.fire({
                      icon: "error",
                      title: "Ocurrio un error",
                      text: error.response.data.message,
                    });
                  });
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          });

    }
  }
}
</script>
